import api from './api';

export const createRecord = (data) => api.post('/api/student-records', data);

export const listRecords = (filters = {}) => api.get('/api/student-records', { params: filters });

export const getRecord = (id) => api.get(`/api/student-records/${id}`);

export const addFollowUp = (recordId, data) => api.post(`/api/student-records/${recordId}/followups`, data);

export const deleteRecord = (id) => api.delete(`/api/student-records/${id}`);
